export enum BlogDataTestIdEnum {
  BLOG_POST_RELATED = 'blog--post-related',
  BLOG_POST_RELATED_CARD = 'blog--post-related-card',
  BLOG_POST_RELATED_CARD_TITLE = 'blog--post-related-card-title',
  BLOG_POST_RELATED_CARD_LINK = 'blog--post-related-card-link',
  BLOG_POST_RELATED_CARD_LINK_TEXT = 'blog--post-related-card-link-text',
  BLOG_POST_RELATED_CARD_LINK_ICON = 'blog--post-related-card-link-icon',
  BLOG_POST_RELATED_CONTAINER = 'blog--post-related-container',
  BLOG_WARNING = 'blog--warning',
  BLOG_SHARE_TO_SOCIAL = 'blog--share-to-social',
  BLOG_POST_CONTENT_CONTAINER = 'blog--post-content-container',
  BLOG_LIST_BY_THEME = 'blog--list-by-theme',
  BLOG_SHARE_TO_SOCIAL_MOBILE = 'main-div--share-to-social-mobile',
  BLOG_THEME_LINK = 'theme-name--theme-list',
  BLOG_ALL_POSTS_LINK = 'all-posts--theme-list',
  BLOG_CAMPAIGN_FORM = 'campaign-form',
  BLOG_CAMPAIGN_TITLE = 'title--campaign-form',
  BLOG_POST_TITLE = '-title--post-card',
  BLOG_POST_CONTENT = '-post--post-card',
  BLOG_POST_DATE = '-publist-date--post-card',
  BLOG_POST_LINK = '--blog-list-post',
  BLOG_THEME_SELECT = 'blog-theme-select',
  NATIVE_SHARE_BUTTON = 'native-share-button--share-to-social-mobile',
  TWITTER_SHARE = 'twitter-share--share-to-social-mobile',
  FALLBACK_SHARE_OPTIONS = 'fallback-share-options--share-to-social-mobile',
  FACEBOOK_SHARE = 'facebook-share--share-to-social-mobile',
  LINKEDIN_SHARE = 'linkedin-share--share-to-social-mobile',
  WHATSAPP_SHARE = 'whatsapp-share--share-to-social-mobile',
  TELEGRAM_SHARE = 'telegram-share--share-to-social-mobile',
  BLOG_POST_HEADER = 'post-header',
  BLOG_POST_HEADER_TITLE = 'title--post-header',
  BLOG_POST_HEADER_DATE = 'publish-date--post-header',
  BLOG_POST_HEADER_THEME_PILL = '-theme-pill--post-header',
  BLOG_POST_CARD_THEME_PILL = '-theme-pill--post-card',
  BLOG_POST_REVIEWER = 'post-reviewer',
  BLOG_POST_REVIEWER_INTERN = 'intern-review--post-reviewer',
  BLOG_POST_REVIEWER_EXTERN = 'extern-review--post-reviewer',
  BLOG_CAMPAIGN_TERMS_SECTION = 'terms-section--campaign-form',
}
